// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MainWindowManager } from '../../UtilsClasses/MainWindowManager';
import { Resources } from '@shared/localizations/Resources';
import { ControlEvents } from '../Control';
import { TerceraDateSelectorDropDown } from './TerceraDateSelectorDropDown';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { TerceraLookup } from './TerceraLookup';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class TerceraDateSelectorLookup extends TerceraLookup {
    constructor() {
        super();
    }
    getType() {
        return 'TerceraDateSelectorLookup';
    }
    oncomplete() {
        super.oncomplete();
        this.observe('expirationTime', (newValue) => {
            this.repopulate(newValue);
        });
        this.textBox.on(ControlEvents.GotFocus, () => {
            this.showForm();
        });
    }
    showForm() {
        var _a;
        const dropDownForm = new TerceraDateSelectorDropDown();
        void dropDownForm.set({ left: this.getX(), top: this.getY(false) + 1 });
        MainWindowManager.AddControl(dropDownForm);
        dropDownForm.on('timeSelectorLookupClosed', () => {
            this.fire('timeSelectorLookupClosed');
            this.closeForm();
        });
        dropDownForm.on('timeSelectorApplyClicked', (context, newDate) => {
            this.onTimeSelectorApplyClicked(newDate);
        });
        dropDownForm.observe('date', (newD) => {
            if (!isNullOrUndefined(newD)) {
                void this.set('expirationTime', newD);
            }
        }, { init: false });
        const today = new Date();
        today.setSeconds(0, 0);
        void dropDownForm.set({
            date: (_a = this.get('expirationTime')) !== null && _a !== void 0 ? _a : today,
            isOnlyDate: this.get('isOnlyDate'),
            header: this.get('datePickerHeader'),
            buttons: this.get('datePickerButtons'),
            parentContainerControl: this.get('parentContainerControl')
        });
        dropDownForm.on('complete', () => {
            this.setMinMax(dropDownForm);
        });
        this.fire('timeSelectorLookupOpened');
        void this.set('isFormShowed', true);
    }
    setMinMax(dropDownForm) {
        let maxDate = null;
        if (this.get('isTodayMaxMode')) {
            maxDate = new Date();
        }
        let minDate = this.get('minDate');
        if (isNullOrUndefined(minDate) && this.get('isTodayMinMode')) {
            minDate = new Date();
        }
        dropDownForm === null || dropDownForm === void 0 ? void 0 : dropDownForm.setMinMax(minDate, maxDate);
    }
    onTimeSelectorApplyClicked(newDate) {
        this.fire('changedDate', newDate);
    }
    getButtonTooltip() {
        return Resources.getResource(this.get('btnTooltip'));
    }
    repopulate(newDate) {
        if (!isNullOrUndefined(newDate)) {
            this.setItems({ text: DateTimeUtils.formatDate(newDate, 'DD.MM.YYYY HH:mm') });
        }
        else {
            this.setItems({ text: 'No Data' });
        }
        this.setSelectValue(this.items[0]);
    }
    getContextMenuItem() {
        return {
            type: NewContextMenuItemType.Default,
            text: this.get('datePickerHeader'),
            enabled: this.get('enabled'),
            svgImage: this.get('svgImage'),
            event: () => {
                this.showForm();
            }
        };
    }
}
TerceraLookup.extendWith(TerceraDateSelectorLookup, {
    data: function () {
        return {
            btnClass: 'js-lookup-datetime-btn',
            btnName: 'showDateLookup',
            name: 'TerceraDateSelectorLookup',
            expirationTime: null,
            isReadOnly: true,
            canSelect: false,
            btnTooltip: 'screen.Alerts.Label.Expiration.Tooltip',
            isTodayMinMode: false,
            isTodayMaxMode: false,
            showDisabledToolTip: true,
            datePickerHeader: '',
            datePickerButtons: [],
            minDate: null,
            svgImage: null
        };
    },
    selectedDate: null
});
